export default __webpack_public_path__ + "static/media/institution.cedf4e50.svg";